/**
 * ns.wow Cookies
 * Facade class for public accessible plugin functionality.
 */

import 'web-animations-js';

class Plugin {

	init() {
		const notice = document.querySelector('.js-nhscookie-note');
		const button = document.querySelector('.js-nhscookie-note-button');
		if (!this.getCookie('nhs-notice')) {
			notice.style.display = 'block';
		}
		button.addEventListener('click', (event) => {
			notice.style.display = 'none';
			event.preventDefault();
			this.setCookie('nhs-notice', 'true', 365);
		});
	}

	getCookie(cookieName) {
		let i;
		let x;
		let y;
		const ARRcookies = document.cookie.split(';');
		for (i = 0; i < ARRcookies.length; i++) {
			x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
			y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
			x = x.replace(/^\s+|\s+$/g, '');
			if (x === cookieName) {
				return unescape(y);
			}
		}
		return false;
	}

	setCookie(name, value, days) {
		let expires = '';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	}

}

export default new Plugin();
